import { RadioGroup } from '@mui/material';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { TrlFormControlLabel, TrlRadioButton } from '»components/atoms';
import { TrlFieldContainer } from '»components/atoms/Inputs/TrlFieldContainer';
import { TrlLockedField } from '»components/atoms/Inputs/TrlLockedField';
import { TrlFormHelperText } from '»components/atoms/TrlFormHelperText';

import { FormControlStyled } from './TrlFormRadioGroup.styles';

export const TrlFormRadioGroup = ({
  className,
  name,
  label,
  options,
  isHidden,
  isRequired,
  noPadding,
  filesPage,
  additionalFunc,
  extraInfo,
  disabled,
  isLocked,
  warningText,
}) => (
  <Field name={name}>
    {({ field, meta }) => (
      <FormControlStyled
        className={className}
        filesPage={filesPage}
        isHidden={isHidden}
        disabled={disabled}
      >
        <TrlFieldContainer
          noPadding={noPadding}
          label={label}
          isRequired={isRequired && !disabled && !isLocked}
          extraInfo={extraInfo}
          disabled={disabled}
        >
          {isLocked ? (
            <TrlLockedField
              showAlertIcon={!!warningText}
              value={options.find((option) => option.id === field.value)?.label}
            />
          ) : (
            <RadioGroup
              name={name}
              defaultValue={options[0]?.id}
              value={meta.value}
              onChange={(event) => {
                field.onChange(event);
                if (additionalFunc) additionalFunc(event);
              }}
            >
              {options.map((option) => {
                const { id, label: optionLabel } = option;

                return (
                  <TrlFormControlLabel key={id} id={id} label={optionLabel}>
                    <TrlRadioButton id={id} name={name} value={id} />
                  </TrlFormControlLabel>
                );
              })}
            </RadioGroup>
          )}
        </TrlFieldContainer>
        {!!warningText && (
          <TrlFormHelperText
            helperType="warning"
            helperText={warningText}
            marginInline="8px 5px"
          />
        )}
      </FormControlStyled>
    )}
  </Field>
);

TrlFormRadioGroup.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  isHidden: PropTypes.bool,
  noPadding: PropTypes.bool,
  filesPage: PropTypes.bool,
  isRequired: PropTypes.bool,
  additionalFunc: PropTypes.func,
  extraInfo: PropTypes.string,
  disabled: PropTypes.bool,
  isLocked: PropTypes.bool,
  warningText: PropTypes.string,
};
